import React from 'react'

const Barnav = () => {
  return (
    <div className='barnav'><h1>INVENTARIO MINA AUSTRALIA</h1></div>
  )
}

export default Barnav